import { useState, useEffect, type Dispatch, type SetStateAction } from 'react'

// Shared state outside the hook to ensure all instances sync
// 10 minutes and 43 seconds = 643 seconds
let sharedRemainingTime = 643
const listeners = new Set<Dispatch<SetStateAction<number>>>()

let intervalId: ReturnType<typeof setInterval> | null = null

const startInterval = () => {
  if (!intervalId) {
    intervalId = setInterval(() => {
      if (sharedRemainingTime > 0) {
        sharedRemainingTime -= 1
      }
      listeners.forEach((listener) => listener(sharedRemainingTime))
    }, 1000)
  }
}

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(sharedRemainingTime)

  useEffect(() => {
    listeners.add(setTimeLeft)
    startInterval()

    return () => {
      listeners.delete(setTimeLeft)
      if (listeners.size === 0 && intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isZero: timeLeft === 0,
  }
}
